export default "__VITE_ASSET__CcFYdGni__"